module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-Extended-68b56a7dde5e3ed464e6ec8ff98d73dd.ttf";